<div
  #tooltipContentRef
  role="tooltip"
  class="med-tooltip__tooltip-wrap"
  [style.max-width]="medTooltip.maxWidth"
>
  <div class="med-tooltip__tooltip">
    <ng-template medHost></ng-template>

    <div
      data-popper-arrow
      class="med-tooltip__arrow"
    ></div>
  </div>
</div>
